<template>
	<div>
		<el-header class="flex space-between" style="width: 100%;margin-bottom:1px">
			<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal">
				<el-menu-item index="0">
					编辑项目
					<span></span>
				</el-menu-item>
				<el-menu-item index="1">
					发布项目
					<span></span>
				</el-menu-item>
				<el-menu-item index="2">
					数据报表
					<span></span>
				</el-menu-item>
			</el-menu>
			<div style="cursor: pointer;margin-right: 20px;font-size: 18px" @click="preview">预览</div>
		</el-header>
		<div class="flex" style="height: 100%">
			<el-menu default-active="2" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" style="height: 100%;position: absolute;width: 360px">
				<el-submenu index="1">
					<template slot="title">
						<i class="el-icon-tickets"></i>
						<span style="font-size: 20px;color: #333">答题限制</span>
					</template>
					<el-menu-item-group>
						<template slot="title">
							答题次数
						</template>
						<el-menu-item index="1-1" class="flex space-between align-items">
							每个微信答题次数限制
							<el-switch v-model="value" active-color="#666" inactive-color="#0080ff"></el-switch>
						</el-menu-item>
						<el-menu-item index="1-2" class="flex space-between align-items">
							每台电脑或手机答题次数限制
							<el-switch v-model="value" active-color="#666" inactive-color="#0080ff"></el-switch>
						</el-menu-item>
						<el-menu-item index="1-3" class="flex space-between align-items">
							每个IP答题次数限制
							<el-switch v-model="value" active-color="#666" inactive-color="#0080ff"></el-switch>
						</el-menu-item>
					</el-menu-item-group>
					<el-menu-item-group title="答题限制">
						<el-menu-item index="1-3" class="flex space-between align-items">
							启动访问密码
							<el-switch v-model="value" active-color="#666" inactive-color="#0080ff"></el-switch>
						</el-menu-item>
						<el-menu-item index="1-3" class="flex space-between align-items">
							限定手机号答题
							<i class="el-icon-arrow-right"></i>
						</el-menu-item>
						<el-menu-item index="1-3" class="flex space-between align-items">
							只有邮件邀请的受访者可回答
							<el-switch v-model="value" active-color="#666" inactive-color="#0080ff"></el-switch>
						</el-menu-item>
						<el-menu-item index="1-3" class="flex space-between align-items">
							设置开始/结束时间
							<el-switch v-model="value" active-color="#666" inactive-color="#0080ff"></el-switch>
						</el-menu-item>
						<el-menu-item index="1-3" class="flex space-between align-items">
							只能通过微信回答
							<el-switch v-model="value" active-color="#666" inactive-color="#0080ff"></el-switch>
						</el-menu-item>
						<el-menu-item index="1-3" class="flex space-between align-items">
							只能通过微信回答
							<el-switch v-model="value" active-color="#666" inactive-color="#0080ff"></el-switch>
							<!--<div style="font-size: 14px;color: #666;flex-wrap: wrap" class="flex">-->
							<!--填写者在填写过程中，可以关闭页面。下次打开可以继续上一次的作答进行继续答题-->
							<!--</div>-->
						</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-submenu index="2">
					<template slot="title">
						<i class="el-icon-tickets"></i>
						<span style="font-size: 20px;color: #333">答题限制</span>
					</template>
				</el-submenu>
				<el-menu-item index="3" disabled>
					<i class="el-icon-document"></i>
					<span slot="title">导航三</span>
				</el-menu-item>
				<el-menu-item index="4">
					<i class="el-icon-setting"></i>
					<span slot="title">导航四</span>
				</el-menu-item>
			</el-menu>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Add',
	data() {
		return {
			activeIndex: '1',
			value: ''
		};
	},
	methods: {
		preview() {
			this.$router.push({ path: '/preview' });
		},
		handleOpen() {},
		handleClose() {}
	}
};
</script>

<style scoped>
.el-menu--horizontal > .el-menu-item.is-active {
	border-bottom: 0px solid #409eff;
	color: #303133;
	position: relative;
}
.el-menu--horizontal > .el-menu-item.is-active span {
	display: block;
	position: absolute;
	width: 26px;
	height: 4px;
	border-radius: 2px;
	background: #409eff;
	left: 50%;
	top: 90%;
	transform: translate(-50%, -50%);
}
.el-menu-item-group__title {
	font-size: 16px;
	color: #333;
}
</style>
